export default "__VITE_ASSET__CnTrrmak__"